export function pathForSetIn(path) {
    //Генерируем путь из массива строк
    const new_path = path.flatMap((index) => {
        return [index.toString(), 'Children'];
    });
    return {
        with_children: new_path,
        without_children: new_path.slice(0, -1),
    };
}
